module.exports = __webpack_public_path__ + "img/bb_g3_ears-02.27f87332.svg";